function initCommunityImpact() {
	initAnimation();
}

function initAnimation() {
	const communityBlock = gsap.utils.toArray(
		'.block-community-impact__content'
	);

	if (!communityBlock.length) return;

	communityBlock.forEach((block) => {
		const itemsNumber = block.querySelectorAll(
			'.communities-impact-container > .item > .total-number > .number'
		);

		const itemAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: block,
				start: 'top 75%',
				toggleActions: 'restart none none reverse',
			},
		});

		itemAnimation.from(itemsNumber, {
			textContent: 0,
			duration: 3,
			snap: { textContent: 1 },
			onUpdate: () => itemsNumber.forEach(changeContentNumberFormat),
		});
	});
}

function changeContentNumberFormat(content) {
	content.textContent = new Intl.NumberFormat().format(+content.innerHTML);
}

document.addEventListener('DOMContentLoaded', () => {
	initCommunityImpact();
});
